<template>
  <div
    v-if="estimatedDelivery && product.status"
    class="product-configurator__shipping-estimate"
  >
    {{ estimatedDelivery }}
  </div>
</template>

<script>
import { ref, onMounted, defineComponent } from '@nuxtjs/composition-api';
import getEstimatedDelivery from '~/helpers/product/getEstimatedDelivery';

export default defineComponent({
  name: 'EstimatedDelivery',
  components: {},
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { getEstimatedDeliveryLabel } = getEstimatedDelivery();

    const estimatedDelivery = ref();

    onMounted(() => {
      estimatedDelivery.value = getEstimatedDeliveryLabel(props.product);
    });

    return {
      estimatedDelivery,
    };
  },
});
</script>

<style lang="scss" scoped>
.product-configurator__shipping-estimate {
  text-transform: uppercase;
  @include label-s;
  width: fit-content;
  margin: 0 auto;
  color: #808080;
}
@include from-desktop-min {
  .product-configurator__shipping-estimate {
    max-width: 27.25rem;
  }
}
</style>
